import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConstants } from 'src/app/app.constants';
import { BehaviorSubject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  api_cost = '/assets/mockdata/API_COST.json';
  dropdown_path = '/assets/mockdata/Api_CostDropdown.json';
  msgObs$ = new BehaviorSubject(null);
  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }


  fetchcostAPI() {
    return this.http.get(this.api_cost);

  }

  // getNdaDetails(ndaValue): Observable<any[]> {
  // let paramsInput = new HttpParams();
  // paramsInput = paramsInput.append('brand_name', searchValue);
  // return this.http.get<any[]>(`${AppConstants.API_ENDPOINT}${AppConstants.API.DETAILS.GET}`, { params: paramsInput })
  // }

  getDropdownData(ndaValue): Observable<any[]> {
    let data = ndaValue.split(',')
    return this.http.get<any[]>(`${AppConstants.API_ENDPOINT}${AppConstants.API.COSTAPI.GET}?brand_name_proprietary_name=${data[0]}&active_ingredient=${data[2]}, FOR SUSPENSION&nda_number=${data[1]}`).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getCostAPI(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.POSTAPI.POST}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }


}
